/** Fictional origin used only to let the URL parser normalise and classify a redirect target. */
const APP_ORIGIN = "http://pmo.invalid";

/**
 * Restricts a post-login destination (router state or a `?from=` query) to an in-app path so that a crafted link
 * can never bounce a freshly signed-in user to another site. Anything that is not a same-origin absolute path,
 * including protocol-relative `//host`, backslash tricks and scheme-prefixed strings, resolves to `fallback`.
 */
export function getSafeRedirect(target: unknown, fallback: string): string {
  if (typeof target !== "string" || !target.startsWith("/")) return fallback;
  try {
    const url = new URL(target, APP_ORIGIN);
    if (url.origin !== APP_ORIGIN) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
